import Service from "../Service";

const resource = "instructionattendance/";

export default {
  pagination(dtr, requestID) {
    return Service.post(resource + "pagination", dtr, {
      params: { requestID: requestID },
    });
  },

  paginationList(IinID, PrsDocumentNumber, IasDate, requestID) {
    return Service.post(resource + "paginationList", {}, {
      params: { IinID: IinID, PrsDocumentNumber: PrsDocumentNumber, IasDate: IasDate, requestID: requestID },
    });
  },

  paginationInducction(PrsDocumentNumber, type, requestID) {
    return Service.post(resource + "paginationInducction", {}, {
      params: { PrsDocumentNumber: PrsDocumentNumber, type: type, requestID: requestID },
    });
  },

  save(ins, requestID) {
    return Service.post(resource + "save", ins, {
      params: { requestID: requestID },
    });
  },
  excel(dtr, requestID) {
    return Service.post(resource + "excel", dtr, {
      params: { requestID: requestID },
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    });
  },
};
